import React, { useContext, useEffect } from "react";
import {
  AiOutlineBranches,
  AiOutlineControl,
  AiOutlineNodeIndex,
  AiOutlineUser,
} from "react-icons/ai";
import { BiRectangle, BiUser } from "react-icons/bi";
import { TiFlowSwitch } from "react-icons/ti";
import FlowContext from "../../../../contexts/flowContext";
import SidebarContext from "../../../../contexts/sidebar";
import styles from "./navigation.module.css";

const items = [
  {
    label: "Flux",
    key: "flow",
    icon: <AiOutlineControl />,
    className: styles.menu_item,
  },
  {
    label: "Noeud",
    key: "node",
    icon: <AiOutlineBranches />,
    className: styles.menu_item,
  },
  {
    label: "Lien",
    key: "edge",
    icon: <AiOutlineNodeIndex />,
    className: styles.menu_item,
  },
  {
    label: "User",
    key: "user",
    icon: <AiOutlineUser />,
    className: styles.menu_item,
  },
];

const Navigation = () => {
  const [sidebarState, sidebarDispatcher] = useContext(SidebarContext);
  const [, flowDispatcher] = useContext(FlowContext);

  useEffect(() => {}, []);

  const onClick = (e) => {
    sidebarDispatcher({
      type: "set-manager",
      manager: e.key,
    });
    if (e.key === "flow") {
      flowDispatcher({
        type: "unselect-all-nodes",
      });
      flowDispatcher({
        type: "unselect-all-edges",
      });
    }
  };

  const handleMenuItemClick = function (e) {
    if (!sidebarState.active) {
      sidebarDispatcher({
        type: "open",
        manager: e.currentTarget.dataset.key,
      });
    } else {
      sidebarDispatcher({
        type: "set-manager",
        manager: e.currentTarget.dataset.key,
      });
    }
    if (e.currentTarget.dataset.key === "flow") {
      flowDispatcher({
        type: "unselect-all-nodes",
      });
      flowDispatcher({
        type: "unselect-all-edges",
      });
    }
  };

  return (
    <div className={styles.menu_container}>
      {/*<Menu onClick={onClick} style={{height: "64px"}} selectedKeys={[sidebarState.manager]} mode="horizontal" items={items} />*/}
      <div
        className={`${styles.menu} ${
          sidebarState.active ? styles.menu_active : ""
        }`}
      >
        <div
          className={`${styles.menu_item} 
                        ${
                          sidebarState.manager === "flow" && sidebarState.active
                            ? styles.menu_item_active
                            : ""
                        } 
                        ${
                          !sidebarState.active
                            ? styles.sidebar_active_menu_active
                            : ""
                        }
                        `}
          data-key="flow"
          onClick={handleMenuItemClick}
        >
          <TiFlowSwitch className={styles.menu_item_icon} />
          <span
            className={`${styles.menu_item_text} ${
              sidebarState.active ? styles.menu_item_text_active : ""
            }`}
          >
            Flow
          </span>
        </div>
        <div
          className={`${styles.menu_item} 
                        ${
                          sidebarState.manager === "node"
                            ? styles.menu_item_active
                            : ""
                        } 
                        ${
                          !sidebarState.active
                            ? styles.sidebar_active_menu_active
                            : ""
                        }
                        `}
          data-key="node"
          onClick={handleMenuItemClick}
        >
          <BiRectangle className={styles.menu_item_icon} />
          <span
            className={`${styles.menu_item_text} ${
              sidebarState.active ? styles.menu_item_text_active : ""
            }`}
          >
            Node
          </span>
        </div>
        <div
          className={`${styles.menu_item} 
                        ${
                          sidebarState.manager === "edge"
                            ? styles.menu_item_active
                            : ""
                        } 
                        ${
                          !sidebarState.active
                            ? styles.sidebar_active_menu_active
                            : ""
                        }
                        `}
          data-key="edge"
          onClick={handleMenuItemClick}
        >
          <AiOutlineNodeIndex className={styles.menu_item_icon} />
          <span
            className={`${styles.menu_item_text} ${
              sidebarState.active ? styles.menu_item_text_active : ""
            }`}
          >
            Edge
          </span>
        </div>
        <div
          className={`${styles.menu_item} 
                        ${
                          sidebarState.manager === "user"
                            ? styles.menu_item_active
                            : ""
                        }
                         ${
                           !sidebarState.active
                             ? styles.sidebar_active_menu_active
                             : ""
                         }
                        `}
          data-key="user"
          onClick={handleMenuItemClick}
        >
          <BiUser className={styles.menu_item_icon} />
          <span
            className={`${styles.menu_item_text} ${
              sidebarState.active ? styles.menu_item_text_active : ""
            }`}
          >
            User
          </span>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
